// extracted by mini-css-extract-plugin
export default {"error":"errorMessage_error__DacXA"};